import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, renderSlot as _renderSlot, isRef as _isRef, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-7ce77170"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "upload"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 点击上传文件:     ");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("点击上传");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("下载模板");

const _hoisted_5 = {
  class: "desc"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "18px"
  }
}, "帮助说明", -1));

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "#333",
    "font-size": "16px"
  }
}, "导入失败, 详情如下:", -1));

const _hoisted_8 = {
  key: 0,
  style: {
    "color": "rgba(0, 0, 0, 0.65)",
    "font-size": "14px",
    "line-height": "25px",
    "padding-left": "12px"
  }
};

const _hoisted_9 = /*#__PURE__*/_createTextVNode(", 修正后重新导入) ");

import { computed, nextTick, ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { getVexTableProps } from '@/config';
import { exportExcel } from '@/utils';
export default {
  name: 'UploadModal',
  props: {
    option: {
      type: Object,
      default: () => ({})
    },
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['success', 'update:modelValue'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });

    function beforeUpload(rawFile) {
      if (!/.(xls|xlsx|csv)$/.test(rawFile.name)) {
        ElMessage.error('上传文件必须是 xls 或 xlsx 格式的文件');
        return false;
      }

      return true;
    }

    const uploadRef = ref();
    const uid = ref(0);
    const showErrorModal = ref(false);
    const errorData = ref(null);
    const table = ref();
    let errorTableSourceData = [];

    function onSuccess(data) {
      if (!data.success) {
        ElMessage.error({
          dangerouslyUseHTMLString: true,
          message: data.message || data.msg || data.msgHead
        });
      } else {
        ElMessage.success({
          dangerouslyUseHTMLString: true,
          message: data.message || data.msg || data.msgHead || '操作成功!'
        });
      }

      uid.value++;

      if (data.success) {
        var _data$data$failRows;

        if (((_data$data$failRows = data.data.failRows) === null || _data$data$failRows === void 0 ? void 0 : _data$data$failRows.length) > 0) {
          // 有失败信息
          errorData.value = data.data; // 错误信息表格赋值

          showErrorModal.value = true; // 展示错误信息表格
        }

        visible.value = false; // 关闭上传表格
      }

      emit('success', data);
    } // 错误信息弹框相关逻辑


    const tableOptions = getVexTableProps({
      scrollX: {
        enabled: true
      },
      showOverflow: true,
      // 弹窗内 tooltip 需高于 el-dialog（默认约 2000+），否则错误原因会显示在弹窗后面
      tooltipConfig: {
        zIndex: 10000
      },
      columns: [],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            res({
              total: errorTableSourceData.length,
              result: errorTableSourceData.slice(page.pageSize * (page.currentPage - 1), page.pageSize * page.currentPage)
            });
          })
        }
      },
      maxHeight: '600px'
    });
    watch(() => errorData.value, newVal => {
      if (newVal) {
        nextTick(() => {
          var _table$value;

          // 设置表头
          // const columns = [{ field: 'excelRowNum', title: 'Excel行号', width: 100 }];
          const columns = [];
          newVal.heads.forEach(item => {
            columns.push({
              field: item.columnName,
              title: item.lastHead,
              minWidth: 150
            });
          });
          columns.push({
            field: 'error',
            title: '错误原因',
            minWidth: 200
          });
          (_table$value = table.value) === null || _table$value === void 0 ? void 0 : _table$value.reloadColumn(columns); // 更新表格数据

          let data = newVal.failRows.map(item => {
            item.error = '';

            if (item.rowError && item.rowError.length > 0) {
              item.error = item.rowError.join(';');
            }

            let keys = Object.keys(item.columnError);

            if (keys.length > 0) {
              keys.forEach(key => {
                var _columns$find;

                const title = (_columns$find = columns.find(i => i.field === key)) === null || _columns$find === void 0 ? void 0 : _columns$find.title;
                item.error += item.columnError[key].join(';') + '\n';
              });
            }

            return item;
          });
          errorTableSourceData = data;
        });
      }
    });

    function downLoadTemplate() {
      window.open(props.option.templateLink, '_blank');
    }

    const exportData = () => {
      const columns = table.value.getColumns();
      const headers = columns.map(i => i.title);
      console.log(columns);
      const dataList = errorTableSourceData.map(data => columns.map(col => data[col.field]));
      const sheet = [headers, ...dataList];
      exportExcel({
        data: sheet,
        fileName: (props.option.errorExcelName || '失败数据') + '.xlsx'
      }); // table.value.exportData({ type: 'csv' });
    };

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_upload = _resolveComponent("el-upload");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _component_el_alert = _resolveComponent("el-alert");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_dialog, {
        title: __props.option.title,
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(visible) ? visible.value = $event : null),
        "destroy-on-close": "",
        width: "800px"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_row, {
          style: {
            "margin-bottom": "20px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 7
          }, {
            default: _withCtx(() => [(_openBlock(), _createBlock(_component_el_upload, {
              action: __props.option.action,
              multiple: false,
              key: uid.value,
              data: __props.option.data,
              name: __props.option.name,
              limit: 1,
              "before-upload": beforeUpload,
              "on-success": onSuccess,
              ref_key: "uploadRef",
              ref: uploadRef,
              "show-file-list": false
            }, {
              default: _withCtx(() => [_hoisted_2, _createVNode(_component_el_button, {
                icon: "Upload",
                type: "primary"
              }, {
                default: _withCtx(() => [_hoisted_3]),
                _: 1
              })]),
              _: 1
            }, 8, ["action", "data", "name"]))]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 5
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              style: {
                "margin-top": "5px"
              },
              link: "",
              onClick: downLoadTemplate
            }, {
              default: _withCtx(() => [_hoisted_4]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createElementVNode("div", _hoisted_5, [_hoisted_6, _renderSlot(_ctx.$slots, "help")])])]),
        _: 3
      }, 8, ["title", "modelValue"]), _createVNode(_component_el_dialog, {
        title: "导入-失败数据",
        modelValue: showErrorModal.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => showErrorModal.value = $event),
        "destroy-on-close": "",
        width: "1000px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_alert, {
          style: {
            "padding": "20px"
          },
          type: "error",
          "show-icon": ""
        }, {
          title: _withCtx(() => [_hoisted_7]),
          default: _withCtx(() => [errorData.value ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", null, " 共上传" + _toDisplayString(errorData.value.excelImportState.totalRows) + "条数据, 成功" + _toDisplayString(errorData.value.excelImportState.successRows) + "条, 失败" + _toDisplayString(errorData.value.excelImportState.failRows) + "条, 重复数据" + _toDisplayString(errorData.value.excelImportState.repeat) + "条 ", 1), _createElementVNode("div", null, [_createTextVNode(" 导入数据存在" + _toDisplayString(errorData.value.excelImportState.errorCount) + "个错误, 详情表格如下(您可以 ", 1), _createElementVNode("span", {
            style: {
              "color": "#1890ff",
              "cursor": "pointer"
            },
            onClick: exportData
          }, "下载导入失败数据"), _hoisted_9])])) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_vxe_grid, _mergeProps({
          ref_key: "table",
          ref: table
        }, _unref(tableOptions)), null, 16)]),
        _: 1
      }, 8, ["modelValue"])], 64);
    };
  }

};